<template>
  <section>
    <Feature title="Data" :iconClass="'fa-pencil-square-o'">
      <FormRow :fieldNameArr="['Form No']">
        <Input v-model="formNo" slot="a" disabled />
      </FormRow>
      <Table :columns="quotationColumnList" :data="quotationList" row-key="key">
        <template slot-scope="{ row, index }" slot="historyComments">
          <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showHistoryCommentsModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="rfqType">
          <span>{{ row.rfqType.description }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="infoRecord">
          <div v-if="row.infoRecordFlag">
            <span>YES</span>
            <Icon type="ios-create" size="28" class="text-delta-blue" @click="showInfoRecordMaintainModal(index, row.uuid)" />
          </div>
          <div v-else>
            <span>NO</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="highPrice">
          <div v-if="row.highPrice && row.quotationHighPrice">
            <Icon type="ios-warning" size="28" class="text-delta-red" />
            <span>{{ row.quotationHighPrice.priceDifference }}%</span>
            <br/>
            <span>{{ row.quotationHighPrice.orgCheck === 'C' ? 'Cross' : 'Single' }}</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="abnormals">
          <Icon v-if="params.row.abnormals && params.row.abnormals.length > 0" type="ios-warning" size="28" class="text-delta-red" @click="showAbnormals(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="deltaPnAndPnDescription">
          <div>{{ row.deltaPart ? row.deltaPart : "" }}<br>{{ row.deltaPartDesc ? row.deltaPartDesc : "" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="vendorCodeAndVendorName">
          <div>{{ row.vendorCode ? row.vendorCode : "" }}<br>{{ row.vendorName ? row.vendorName : "" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="unitPriceAndCurrency">
          <div v-if="(row.abnormals && row.abnormals.quoteRedAlert) || row.quoteRedAlert">
            <Button type="error" style="width: 80%" shape="circle" size="small">{{ row.price }}</Button>
            <span>/{{ row.currency }}</span>
          </div>
          <div v-else>{{ row.price ? row.price : "" }}/{{ row.currency ? row.currency : "" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="averagePurchasePriceAndCurrency">
          <div v-if="row.averagePurchasePrice !== undefined">{{ row.averagePurchasePrice.price }}/{{ row.averagePurchasePrice.currency }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="plmFiles">
          <Icon type="md-download" size="28" class="text-delta-blue" @click="showPlmFilesModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="quotationFiles">
          <Icon :type="row.supplierAttachments && row.supplierAttachments.filter(attachement => !attachement.deleted).length > 0 ? 'ios-cloud-download' : ''" size="28" class="text-delta-blue" @click="showQuotationFilesModal(index)" />
        </template>
        <template slot-scope="{ row, index }" slot="scalePrice">
          <Icon :type="row.scalePrices && row.scalePrices.length > 0 ? 'md-reorder' : ''" size="28" class="text-delta-blue" @click="showScalePriceModal(index)" />
        </template>
        <template slot-scope="{ row, index }" slot="referencePriceData">
          <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showReferencePriceDataModal(index, row.uuid, row.rfqType.rfqTypeEnum)" />
        </template>
        <template slot-scope="{ row, index }" slot="rawMaterialPriceAndUnit">
          <div>{{ row.rawMaterialPrice ? row.rawMaterialPrice : "" }}/{{ row.rawMaterialUnit ? row.rawMaterialUnit : "" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="remark">
          <Icon v-if="row.resourceType === 'SupervisorQuotationDetailDto'" type="ios-create" size="28" class="text-delta-blue" @click="showRemarkModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="ymgrRemark">
          <div>{{ row.ymgrRemark }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="log">
          <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showLogModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="categoryAttributes">
          <Icon v-if="rfqType.rfqTypeEnum === 'COMPONENT' && row.category && row.category !== 'OTHERS'" type="ios-paper" size="28" class="text-delta-blue" @click="showCategoryAttributesModal(index)" />
        </template>
        <template slot-scope="{ row, index }" slot="itemCategory">
          <span v-if="quotationList[index].itemCategory === 'STANDARD'">Standard</span>
          <span v-if="quotationList[index].itemCategory === 'SUBCONTRACTION'">Subcontraction</span>
        </template>
        <template slot-scope="{ row, index }" slot="validFromAndValidTo">
          <DatePicker v-model="quotationList[index].validFrom" type="date" format="yyyy-MM-dd" placeholder="Select Date" :disabled="true"></DatePicker>
          <DatePicker v-model="quotationList[index].validTo" type="date" format="yyyy-MM-dd" placeholder="Select Date" :disabled="true"></DatePicker>
        </template>
        <template slot-scope="{ row, index }" slot="approveReferenceFile">
          <Icon :type="row.cpcToSupervisorAttachments && row.cpcToSupervisorAttachments.filter(attachement => !attachement.deleted).length > 0 ? 'ios-cloud-download' : ''" size="28" class="text-delta-blue" @click="showApproveReferenceFileModal(index)" />
        </template>
        <template slot-scope="{ row, index }" slot="rejectReferenceFile">
          <Icon :type="row.cpcToVendorAttachments && row.cpcToVendorAttachments.filter(attachement => !attachement.deleted).length > 0 ? 'ios-cloud-download' : ''" size="28" class="text-delta-blue" @click="showRejectReferenceFileModal(index)" />
        </template>
      </Table>
    </Feature>
    <ButtonRow>
      <Button type="info" @click="download" slot="1">{{ $t("DOWNLOAD") }}</Button>
      <Button type="info" @click="back" slot="2">{{ $t("BACK") }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="historyCommentsModal"
      :title="$t('HISTORY') + ' ' + $t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="historyComments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="infoRecordMaintainModal" :title="$t('INFO_RECORD_MAINTAIN')">
      <InfoRecordMaintain v-if="infoRecordMaintainModal" :quotation="quotation" :materialTypeList="materialTypeList" :readonly="true"></InfoRecordMaintain>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="plmFileModal" :title="$t('PLM_FILES')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <PLMDocument :plmQuotationDocuments="quotationDocuments" :quotationUuid="quotationUuid"></PLMDocument>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="supplierQuotationFilesModal" :title="$t('QUOTATION_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="supplierAttachments"></FileDocument>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="scalePricesModal" :title="$t('SCALE_PRICE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="scalePriceColumnList" :data="scalePrices" :max-height="550"></Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1400" v-model="referencePriceModal" :title="$t('REFERENCE_PRICE_DATA')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="rfqType.rfqTypeEnum === 'TOOLING' ? referencePriceColumnListForTooling : referencePriceColumnListForOthers" :data="referencePrices" :max-height="550"></Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logModal" :title="$t('PROCESS_LOG')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <TablePage :columnsList="quotationLogColumnList" :resultList="quotationLogList" :tableMaxHeight="550"></TablePage>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="flowCommentModal" :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="flowComment"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="metalAttributeModal" :title="$t('METAL_CASE_ATTRIBUTES')">
      <MetalAttributes :metalQuotation="metalQuotation" :referencePrice="referencePrice" :priceList="priceList">
      </MetalAttributes>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="plasticAttributeModal" :title="$t('PLASTIC_CASE_ATTRIBUTES')">
      <PlasticAttributes :plasticQuotation="plasticQuotation" :referencePrice="referencePrice" :priceList="priceList">
      </PlasticAttributes>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="pwbAttributeModal" :title="$t('PWB_CASE_ATTRIBUTES')">
      <PwbAttributes :pwbQuotation="pwbQuotation" :priceList="priceList"></PwbAttributes>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="approveReferenceFileModal" :title="$t('APPROVE') + ' ' + $t('REFERENCE_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="cpcToSupervisorAttachments"></FileDocument>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="rejectReferenceFileModal" :title="$t('REJECT') + ' ' + $t('REFERENCE_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="cpcToVendorAttachments"></FileDocument>
      </div>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import PLMDocument from '../../components/PLMDocument.vue'
import FileDocument from '../../components/FileDocument.vue'
import { AlertInfo, AlertSuccess } from "@/util/alert"
import { FloraEditorConfig } from "@/util/common"
import MetalAttributes from "@/views/quotation/MetalAttributes"
import PlasticAttributes from "@/views/quotation/PlasticAttributes"
import PwbAttributes from "@/views/quotation/PwbAttributes"
import InfoRecordMaintain from "@/views/quotation/InfoRecordMaintain"

export default {
  name: "StatusReportCpcDetail",
  props: {
    formNo: {
      type: String,
      default: ""
    },
    rfqType: {
      type: Object,
      default: {}
    }
  },
  components: {
    PLMDocument,
    FileDocument,
    MetalAttributes,
    PlasticAttributes,
    PwbAttributes,
    InfoRecordMaintain
  },
  created() {
    const vueInstance = this;
    vueInstance.toggleLoading(true);
    vueInstance.$quotationHttp
      .get("status-report/detail?formNo=" + vueInstance.formNo)
      .then(response => {
        vueInstance.quotationList.push(response.data);
      })
      .catch(error => {
        AlertInfo(vueInstance, vueInstance.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
          .then(() => {
            console.error(error);
            vueInstance.Back();
          });
      })
      .finally(() => {
        vueInstance.toggleLoading(false);
      });
    vueInstance.$quotationHttp
      .get("/quotation/material-type")
      .then(response => {
        if (response.data) {
          vueInstance.materialTypeList = response.data;
        }
      });
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      quotation: {},
      quotationList: [],
      quotationUuid: "",
      materialTypeList: [],
      scalePricesModal: false,
      scalePrices: [],
      referencePriceModal: false,
      referencePrices: [],
      quotationLogList: [],
      supplierAttachments: [],
      cpcToSupervisorAttachments: [],
      cpcToVendorAttachments: [],
      historyComments: "",
      historyCommentsModal: false,
      flowComment: "",
      flowCommentModal: false,
      infoRecordMaintainModal: false,
      plmFileModal: false,
      quotationDocuments: [],
      supplierQuotationFilesModal: false,
      referencePrice: "",
      metalAttributeModal: false,
      metalQuotation: {
        length: "",
        width: "",
        height: "",
        weight: "",
        rawMaterialType: {
          partNo: "",
          partNoDesc: ""
        },
        rmVendor: {
          vendorCode: ""
        },
        coilCenter: {
          vendorCode: ""
        },
        rmPrice: "",
        rmPriceDate: "",
        rmCost: "",
        processingCost: "",
        treatmentCost: "",
        accessoriesCost: "",
        others: "",
        rmRatio: "",
        totalCost: "",
        supplierRemark: ""
      },
      plasticAttributeModal: false,
      plasticQuotation: {
        length: "",
        width: "",
        height: "",
        weight: "",
        model: "",
        resinType: {
          type: ""
        },
        resinVendor: {
          vendorCode: ""
        },
        resinNo: {
          partNo: "",
          partNoDesc: ""
        },
        distributor: {
          vendorCode: ""
        },
        resinColor: "",
        colorNo: "",
        rmPrice: "",
        rmPriceDate: "",
        dyeCost: "",
        cavity: "",
        tannage: "",
        hourlyRate: "",
        cycleTime: "",
        rmCost: "",
        injectingCost: "",
        processingCost: "",
        treatmentCost: "",
        accessoriesCost: "",
        others: "",
        rmRatio: "",
        totalCost: "",
        supplierRemark: ""
      },
      pwbAttributeModal: false,
      pwbQuotation: {
        deltaExchangeRate: "",
        cpcExchangeRate: "",
        rfqBase: "",
        cclLaminateType: "",
        layer: "",
        pcbThickness: "",
        internalCoreThickness: "",
        tg: "",
        externalCopperThickness: "",
        internalCopperThickness: "",
        mainSourceCclSupplier: {
          vendorCode: ""
        },
        mainSourceCclShare: 0,
        mainCoreUlNumber: {
          partNoDesc: ""
        },
        mainCoreUP: "",
        secondSourceCclSupplier: {
          vendorCode: ""
        },
        secondCoreUlNumber: {
          partNoDesc: ""
        },
        secondCoreUP: "",
        pcbPrice: "",
        panelLength: "",
        panelWidth: "",
        pnLength: "",
        pnWidth: "",
        area: "",
        pnArea: "",
        supplierSheetSize: "",
        deltaSheetSize: "",
        panelSheet: "",
        pnInSheet: "",
        pnInPanel: "",
        pnUtilization: "",
        panelUtilization: "",
        combineRatio: "",
        numberOfDrill: "",
        slotLength: "",
        goldArea: "",
        materialCost: "",
        surfaceFinishCost: "",
        processCost: "",
        specialCostDown: "",
        deltaPnPriceUsd: "",
        deltaPnPrice: "",
        supplierRemark: ""
      },
      priceList: [],
      approveReferenceFileModal: false,
      rejectReferenceFileModal: false,
      logModal: false
    };
  },
  methods: {
    ...mapGetters(["getModalSize"]),
    ...mapActions(["toggleLoading"]),
    showHistoryCommentsModal(index, uuid) {
      this.toggleLoading(true);
      this.$queryQuotationLog(this, uuid)
        .then(data => {
          this.quotationUuid = uuid;
          this.historyComments = "";
          data.forEach(log => {
            if (log.quotationRole) {
              this.historyComments = this.historyComments + this.$t("ROLE") + ": " + log.quotationRole + ", ";
            }
            if (log.quotationRole) {
              this.historyComments = this.historyComments + this.$t("STATUS") + ": " + log.flowStatus + ", ";
            }
            if (log.groupAccount) {
              this.historyComments = this.historyComments + this.$t("GROUP_ACCOUNT") + ": " + log.groupAccount.code + "/" + log.groupAccount.companyName + ", ";
            }
            if (log.created) {
              this.historyComments = this.historyComments + this.$t("CREATE_DATE") + ": " + log.created + ": <br>";
            }
            if (log.flowComment) {
              this.historyComments = this.historyComments + log.flowComment;
            }
            this.historyComments = this.historyComments + "<hr style=\"border:1px dashed #000; height:1px\">";
          });
          this.historyCommentsModal = true;
        })
        .catch(error => {
          AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
            .then(() => {
              console.error(error);
            });
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    showInfoRecordMaintainModal(index, uuid) {
      this.quotation = this.quotationList[index];
      this.infoRecordMaintainModal = true;
    },
    showPlmFilesModal(index, uuid) {
      this.toggleLoading(true);
      this.$queryPlmDocuments(this, uuid)
        .then(data => {
          this.quotationUuid = uuid;
          this.quotationDocuments = data;
          this.plmFileModal = true;
        }).catch(error => {
          AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
            .then(() => {
              console.error(error);
            });
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    showQuotationFilesModal(index) {
      this.supplierAttachments = this.quotationList[index].supplierAttachments.filter(attachment => !attachment.deleted);
      this.supplierQuotationFilesModal = true;
    },
    showScalePriceModal(index) {
      this.scalePrices = this.quotationList[index].scalePrices;
      this.scalePricesModal = true;
    },
    showReferencePriceDataModal(index, uuid, rfqType) {
      this.toggleLoading(true);
      if (rfqType === "TOOLING") {
        this.$readTooling(this, this.formNo, false)
          .then(data => {
            this.referencePrices = data.references;
            this.referencePriceModal = true;
          }).catch((error) => {
            AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
              .then(() => {
                console.error(error);
              });
          })
          .finally(() => {
            this.toggleLoading(false);
          });
      } else {
        this.$queryReferencePrice(this, uuid)
          .then(data => {
            this.quotationUuid = uuid;
            this.referencePrices = data;
            this.referencePriceModal = true;
          }).catch(error => {
            AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
              .then(() => {
                console.error(error);
              });
          })
          .finally(() => {
            this.toggleLoading(false);
          });
      }
    },
    showRemarkModal(index, uuid) {
      this.remark = this.quotationList[index].remark;
      this.quotationUuid = uuid;
      this.remarkModel = true;
    },
    showLogModal(index, uuid) {
      this.quotationLogList = this.quotationList[index].logs;
      this.quotationUuid = uuid;
      this.logModal = true;
    },
    showCategoryAttributesModal(index) {
      const vueInstance = this;
      vueInstance.quotation = vueInstance.quotationList[index];
      switch (vueInstance.quotation.category) {
        case "METAL":
          vueInstance.metalQuotation = {};
          vueInstance.metalAttributeModal = true;
          vueInstance.plasticAttributeModal = false;
          vueInstance.pwbAttributeModal = false;
          vueInstance.toggleLoading(true);
          vueInstance.$quotationHttp
            .get("metal/formNo/" + vueInstance.formNo)
            .then(response => {
              vueInstance.metalQuotation = response.data;
              vueInstance.referencePrice = "";
              vueInstance.priceList = [];
              if (vueInstance.metalQuotation.referencePrices) {
                vueInstance.metalQuotation.referencePrices.forEach(price => {
                  vueInstance.referencePrice = vueInstance.referencePrice + price.price + "/" + price.currency + "\n";
                });
              }
              vueInstance.priceList.push({
                key: "RM_COST",
                value: vueInstance.metalQuotation.rmCost
              }, {
                key: "PROCESSING_COST",
                value: vueInstance.metalQuotation.processingCost
              }, {
                key: "TREATMENT",
                value: vueInstance.metalQuotation.treatmentCost
              }, {
                key: "ACCESSORIES",
                value: vueInstance.metalQuotation.accessoriesCost
              }, {
                key: "OTHERS_PROCESS",
                value: vueInstance.metalQuotation.others
              }, {
                key: "RM_RATIO_NO_ACCESSORY",
                value: vueInstance.metalQuotation.rmRatio
              }, {
                key: "TOTAL_COST",
                value: vueInstance.metalQuotation.totalCost
              });
            })
            .catch(error => {
              AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR'))
                .then(() => {
                  console.log(error);
                });
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        case "PLASTIC":
          vueInstance.plasticQuotation = {};
          vueInstance.metalAttributeModal = false;
          vueInstance.plasticAttributeModal = true;
          vueInstance.pwbAttributeModal = false;
          vueInstance.toggleLoading(true);
          vueInstance.$quotationHttp
            .get("plastic/formNo/" + vueInstance.formNo)
            .then(response => {
              vueInstance.plasticQuotation = response.data;
              vueInstance.referencePrice = "";
              vueInstance.priceList = [];
              if (vueInstance.plasticQuotation.referencePrices) {
                vueInstance.plasticQuotation.referencePrices.forEach(price => {
                  vueInstance.referencePrice = vueInstance.referencePrice + price.price + "/" + price.currency + "\n";
                });
              }
              vueInstance.priceList.push({
                key: "RM_COST",
                value: vueInstance.plasticQuotation.rmCost
              }, {
                key: "INJECTION_COST",
                value: vueInstance.plasticQuotation.injectionCost
              }, {
                key: "PROCESSING_COST",
                value: vueInstance.plasticQuotation.processingCost
              }, {
                key: "ACCESSORIES",
                value: vueInstance.plasticQuotation.accessoriesCost
              }, {
                key: "OTHERS_PROCESS",
                value: vueInstance.plasticQuotation.others
              }, {
                key: "RM_RATIO_NO_ACCESSORY",
                value: vueInstance.plasticQuotation.rmRatio
              }, {
                key: "TOTAL_COST",
                value: vueInstance.plasticQuotation.totalCost
              });
            })
            .catch(error => {
              AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR'))
                .then(() => {
                  console.log(error);
                });
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        case "PWB":
          vueInstance.pwbQuotation = {};
          vueInstance.metalAttributeModal = false;
          vueInstance.plasticAttributeModal = false;
          vueInstance.pwbAttributeModal = true;
          vueInstance.toggleLoading(true);
          vueInstance.$quotationHttp
            .get("supplier/pwb/formNo/" + formNo)
            .then(response => {
              vueInstance.pwbQuotation = response.data;
              vueInstance.priceList = [];
              vueInstance.priceList.push({
                key: "MATERIAL_COST",
                value: vueInstance.pwbQuotation.materialCost
              }, {
                key: "SURFACE_FINISH_COST",
                value: vueInstance.pwbQuotation.surfaceFinishCost
              }, {
                key: "PROCESSING_COST",
                value: vueInstance.pwbQuotation.processCost
              }, {
                key: "DELTA_PN_UP_PRICE_USD",
                value: vueInstance.pwbQuotation.deltaPnPriceUsd
              }, {
                key: "DELTA_PN_UP_PRICE",
                value: vueInstance.pwbQuotation.deltaPnPrice
              }, {
                key: "SPECIAL_COST_DOWN",
                value: vueInstance.pwbQuotation.specialCostDown
              });
            })
            .catch(error => {
              AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR'))
                .then(() => {
                  console.log(error);
                });
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
      }
    },
    showApproveReferenceFileModal(index) {
      this.cpcToSupervisorAttachments = this.quotationList[index].cpcToSupervisorAttachments.filter(attachment => !attachment.deleted);
      this.approveReferenceFileModal = true;
    },
    showRejectReferenceFileModal(index) {
      this.cpcToVendorAttachments = this.quotationList[index].cpcToVendorAttachments.filter(attachment => !attachment.deleted);
      this.rejectReferenceFileModal = true;
    },
    back() {
      this.$router.push({
        name: "STATUS_REPORT"
      });
    },
    download() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .get("status-report/cpc-detail/download?formNo=" + vueInstance.formNo)
        .then(() => {
          AlertSuccess(vueInstance, "")
            .then(() => {});
        })
        .catch(error => {
          AlertInfo(vueInstance, vueInstance.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
            .then(() => {
              console.error(error);
              vueInstance.Back();
            });
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    }
  },
  computed: {
    modalSize() {
      return this.getModalSize();
    },
    quotationColumnList() {
      return [{
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("HISTORY"), 
            h("br"), 
            this.$t("COMMENTS")
          ]);
        },
        align: "center",
        width: 70,
        slot: "historyComments"
      }, {
        title: this.$t("RFQ_TYPE"),
        align: "center",
        width: 85,
        slot: "rfqType"
      }, {
        title: this.$t("CATEGORY"),
        align: "center",
        width: 60,
        key: "category"
      }, {
        title: this.$t("INFO_RECORD"),
        align: "center",
        width: 60,
        slot: "infoRecord"
      }, {
        title: this.$t("HIGH_PRICE"),
        align: "center",
        width: 60,
        slot: "highPrice"
      }, {
        title: this.$t("ABNORMAL"),
        width: 60,
        align: "center",
        render: (h, params) => {
          if (params.row.abnormals === undefined) {
            this.$set(this.quotationList[params.index], "abnormals", []);
            this.$queryAbnormals(this, params.row.uuid)
              .then(data => {
                this.$set(this.quotationList[params.index], "abnormals", data);
              })
              .catch(error => {
                AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR'))
                  .then(() => {
                    console.log(error);
                  });
              });
          }
          return h("Icon", {
            props: {
              type: params.row.abnormals ? (params.row.abnormals.length > 0 ? "ios-warning" : "ios-loading") : "",
              size: 28
            },
            class: "text-delta-red",
            on: {
              click: () => {
                if (params.row.abnormals && params.row.abnormals.length > 0) {
                  this.quotationUuid = params.row.uuid;
                  this.abnormals = params.row.abnormals;
                  this.abnormalsModel = true;
                }
              }
            }
          });
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("DELTA_PN"), 
            h("br"), 
            this.$t("PN_DESCRIPTION")
          ]);
        },
        align: "center",
        width: 100,
        slot: "deltaPnAndPnDescription"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("VENDOR_CODE"), 
            h("br"), 
            this.$t("OA_VENDOR_NAME")
          ]);
        },
        align: "center",
        width: 90,
        slot: "vendorCodeAndVendorName"
      }, {
        title: this.$t("VENDOR_PN"),
        align: "center",
        width: 80,
        key: "vendorPartNo"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("TARGET"), 
            h("br"), 
            this.$t("PRICE")
          ]);
        },
        align: "center",
        width: 80,
        key: "targetPrice"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("UNIT_PRICE"), 
            h("br"), 
            this.$t("CURRENCY")
          ]);
        },
        align: "center",
        width: 90,
        slot: "unitPriceAndCurrency"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("AVERAGE_PURCHASE_PRICE"), 
            h("br"), 
            this.$t("CURRENCY")
          ]);
        },
        align: "center",
        width: 90,
        slot: "averagePurchasePriceAndCurrency"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("BASIC"), 
            h("br"), 
            this.$t("UNIT")
          ]);
        },
        width: 50,
        align: "center",
        key: "unit"
      }, {
        title: this.$t("PLANT_CODE"),
        align: "center",
        width: 50,
        key: "plant"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("PLM"), 
            h("br"), 
            this.$t("FILES")
          ]);
        },
        align: "center",
        width: 60,
        slot: "plmFiles"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("QUOTATION"), 
            h("br"), 
            this.$t("FILES")
          ]);
        },
        align: "center",
        width: 60,
        slot: "quotationFiles"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("SCALE"), 
            h("br"), 
            this.$t("PRICE")
          ]);
        },
        align: "center",
        width: 60,
        slot: "scalePrice"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("REFERENCE_PRICE"), 
            h("br"), 
            this.$t("DATA")
          ]);
        },
        align: "center",
        width: 60,
        slot: "referencePriceData"
      }, {
        title: this.$t("RAW_MATERIAL_TYPE"),
        align: "center",
        width: 80,
        key: "rawMaterial"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("RAW_MATERIAL"), 
            h("br"), 
            this.$t("PRICE_UNIT")
          ]);
        },
        align: "center",
        width: 80,
        slot: "rawMaterialPriceAndUnit"
      }, {
        title: this.$t("RM_REMARK"),
        align: "center",
        width: 60,
        slot: "remark"
      }, {
        title: this.$t("YMGR_REMARK"),
        align: "center",
        width: 60,
        slot: "ymgrRemark"
      }, {
        title: this.$t("LOG"),
        align: "center",
        width: 60,
        slot: "log"
      }, {
        title: this.$t("CATEGORY_ATTRIBUTES"),
        align: "center",
        width: 50,
        slot: "categoryAttributes"
      }, {
        title: this.$t("ITEM_CATEGORY"),
        align: "center",
        width: 100,
        slot: "itemCategory"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("VALID_FROM"), 
            h("br"), 
            this.$t("VALID_TO")
          ]);
        },
        align: "center",
        width: 140,
        slot: "validFromAndValidTo"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("APPROVE"), 
            h("br"), 
            this.$t("REFERENCE"), 
            h("br"), 
            this.$t("FILE")
          ]);
        },
        align: "center",
        width: 60,
        slot: "approveReferenceFile"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("REJECT"), 
            h("br"), 
            this.$t("REFERENCE"), 
            h("br"), 
            this.$t("FILE")
          ]);
        },
        align: "center",
        width: 60,
        slot: "rejectReferenceFile"
      }];
    },
    scalePriceColumnList() {
      return [{
        title: 'Item',
        align: "center",
        width: 80,
        key: "item"
      }, {
        renderHeader: (h, params) => {
          return h("div", [
            this.$t("SCALE"),
            h("br"),
            this.$t("QUANTITY")
          ]);
        },
        align: "center",
        width: 80,
        key: "scaleQuantity"
      }, {
        renderHeader: (h, params) => {
          return h("div", [
            this.$t("SCALE"),
            h("br"),
            this.$t("PRICE")
          ]);
        },
        align: "center",
        width: 80,
        key: "scalePrice"
      }];
    },
    referencePriceColumnListForOthers() {
      return [{
        title: this.$t("MATERIAL"),
        align: "center",
        width: 140,
        key: "materialNumber"
      }, {
        renderHeader: (h, params) => {
          return h("div", [
            this.$t("VENDOR_CODE"),
            h("br"),
            this.$t("OA_VENDOR_NAME")
          ]);
        },
        align: "center",
        width: 140,
        render: (h, params) => {
          return h("div", [
            params.row.vendorCode ?? "",
            h("br"),
            params.row.vendorName ?? ""
          ]);
        }
      }, {
        title: this.$t("AGENT"),
        align: "center",
        width: 100,
        key: "agent"
      }, {
        title: this.$t("AGENT_NAME"),
        align: "center",
        width: 140,
        key: "agentName"
      }, {
        title: this.$t("INFO_CATEGORY"),
        align: "center",
        width: 100,
        key: "purchInfoRecordCategory"
      }, {
        title: this.$t("VALID_FROM"),
        align: "center",
        width: 100,
        key: "validFromDate"
      }, {
        title: this.$t("VALID_TO"),
        align: "center",
        width: 100,
        key: "validToDate"
      }, {
        title: this.$t("PLANT_CODE"),
        align: "center",
        width: 100,
        key: "plant"
      }, {
        title: this.$t("CURRENCY"),
        align: "center",
        width: 80,
        key: "currency"
      }, {
        title: this.$t("UNIT_PRICE"),
        align: "center",
        width: 80,
        key: "unitPirce"
      }, {
        title: this.$t("USD_PRICE"),
        align: "center",
        width: 80,
        key: "usdPrice"
      }, {
        title: this.$t("UOM"),
        align: "center",
        width: 80,
        key: "conditionUnit"
      }, {
        title :this.$t("%"),
        align: "center",
        width: 80,
        key: "percentage"
      }];
    },
    referencePriceColumnListForTooling() {
      return [{
        title: this.$t("CREATE_DATE"),
        align: "center",
        width: 200,
        key: "createDate"
      }, {
        title: this.$t("TOOLING_ID"),
        align: "center",
        width: 300,
        key: "toolingId"
      }, {
        title: this.$t("UNIT_PRICE"),
        align: "center",
        width: 250,
        key: "unitPrice"
      }, {
        title: this.$t("CURRENCY"),
        align: "center",
        width: 150,
        key: "currency"
      }, {
        title: this.$t("PLANT"),
        align: "center",
        width: 100,
        key: "plant"
      }, {
        title: this.$t("VENDOR"),
        align: "center",
        width: 200,
        key: "vendor"
      }, {
        title: this.$t("OA_VENDOR_NAME"),
        align: "center",
        width: 300,
        key: "vendorName"
      }, {
        title: this.$t("CAVITY"),
        align: "center",
        width: 150,
        key: "cavity"
      }, {
        title: this.$t("VALID_DATE"),
        align: "center",
        width: 150,
        key: "validationDate"
      }, {
        title: this.$t("LIFETIME"),
        align: "center",
        width: 150,
        key: "lifeTime"
      }, {
        title: this.$t("USED_LIFETIME"),
        align: "center",
        width: 150,
        key: "usedLifeTime"
      }, {
        title: this.$t("COMPARE_PRICE"),
        align: "center",
        width: 150,
        key: "comparePrice"
      }];
    },
    quotationLogColumnList() {
      return [{
        title: this.$t("ROLE"),
        align: "center",
        width: 150,
        key: "quotationRole"
      }, {
        title: this.$t("STATUS"),
        align: "center",
        width: 150,
        key: "flowStatus"
      }, {
        title: this.$t("GROUP_ACCOUNT"),
        align: "center",
        width: 180,
        render: (h, params) => {
          return h("span", {}, params.row["groupAccount"].code + '/' + params.row["groupAccount"].companyName);
        }
      }, {
        title: this.$t("ACTION"),
        align: "center",
        width: 150,
        key: "flowAction"
      }, {
        title: this.$t("COMMENTS"),
        align: "center",
        width: 150,
        render: (h, params) => {
          if (params.row.flowComment) {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.flowComment = params.row.flowComment;
                  this.flowCommentModal = true;
                }
              }
            });
          }
          return h("span", {}, "");
        }
      }, {
        title: this.$t("CREATE_DATE"),
        align: "center",
        width: 180,
        key: "created"
      }, {
        title: this.$t("PERSON_ACCOUNT"),
        align: "center",
        width: 200,
        key: "personEmail"
      }];
    }
  }
}
</script>